import { render, staticRenderFns } from "./descriptionHavoblog.vue?vue&type=template&id=5ac2ae79&scoped=true&"
import script from "./descriptionHavoblog.vue?vue&type=script&lang=js&"
export * from "./descriptionHavoblog.vue?vue&type=script&lang=js&"
import style0 from "./descriptionHavoblog.vue?vue&type=style&index=0&id=5ac2ae79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac2ae79",
  null
  
)

export default component.exports